import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {LipoRouteEnum} from "../../shared/enums/lipo-route.enum";
import {AuthGuardData, createAuthGuard} from "keycloak-angular";


const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  routerState: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
  const {authenticated, grantedRoles} = authData;

  if (authenticated) {
    const requiredRole = route.data['role'];

    if (requiredRole && requiredRole.length > 0) {
      const hasRequiredRole = (role: string): boolean =>
        Object.values(grantedRoles.resourceRoles).some((roles) => roles.includes(role));

      if (hasRequiredRole(requiredRole)) {
        return true;
      }
    } else {
      return true;
    }
  }

  return inject(Router).createUrlTree([LipoRouteEnum.AUTH, LipoRouteEnum.REALM_CHOOSER]);
};

export const canActivateAuthRole = createAuthGuard<CanActivateFn>(isAccessAllowed);
